import { iLTO, LTO } from "@models/LTO";

const buildPreviewItem = (item: Pick<iLTO, 'id' | 'chainName' | 'name' | 'date' | 'description' | 'price' | 'status'>): iLTO => ({
    ...LTO.defaultData,
    ...item,
});

/**
 * Decorative placeholder items shown blurred behind the permission overlay when the user has no Launches & Ratings
 * access and the backend returned no items. Negative ids keep them apart from real items; no image URL, so the tile
 * falls back to the default thumbnail; no scores (isScoresItem stays false).
 */
export const LOCKED_LAUNCHES_PREVIEW_ITEMS: iLTO[] = [
    buildPreviewItem({
        id: -1,
        chainName: "Taco Bell",
        name: "Crispy Diablo Taco Combo",
        date: "2026-03-01",
        description: "A crispy shell taco layered with seasoned beef, fiery diablo sauce, pickled jalapenos and shredded cheese, served as a combo with fries and a drink.",
        price: "$7.99",
        status: "Limited Time",
    }),
    buildPreviewItem({
        id: -2,
        chainName: "Wendy's",
        name: "Spicy Smokehouse Chicken Sandwich",
        date: "2026-02-01",
        description: "Crispy chicken breast with smoked bacon, pepper jack cheese, crunchy pickles and a smoky chipotle sauce on a toasted brioche bun.",
        price: "$6.49",
        status: "New",
    }),
    buildPreviewItem({
        id: -3,
        chainName: "Subway",
        name: "Honey Chipotle Steak Melt",
        date: "2026-01-01",
        description: "Thin-sliced steak with melted provolone, roasted peppers and onions, finished with a sweet honey chipotle glaze on freshly baked bread.",
        price: "$9.29",
        status: "Limited Time",
    }),
    buildPreviewItem({
        id: -4,
        chainName: "Domino's",
        name: "Hot Honey Pepperoni Pizza",
        date: "2025-12-01",
        description: "Hand-tossed crust topped with cupped pepperoni, mozzarella and a drizzle of hot honey for a sweet and spicy finish.",
        price: "$12.99",
        status: "Returning",
    }),
    buildPreviewItem({
        id: -5,
        chainName: "Starbucks",
        name: "Toasted Coconut Cold Brew",
        date: "2025-11-01",
        description: "Slow-steeped cold brew sweetened with toasted coconut syrup and topped with a velvety vanilla sweet cream cold foam.",
        price: "$5.45",
        status: "New",
    }),
    buildPreviewItem({
        id: -6,
        chainName: "Burger King",
        name: "Fiery Crispy Fish Sandwich",
        date: "2025-10-01",
        description: "Panko-crusted white fish fillet with a spicy pepper sauce, crisp lettuce and tangy pickles on a toasted potato bun.",
        price: "$5.99",
        status: null,
    }),
];
